<template>
    <div>
		<el-input-number :controls="false" v-model="min" @input="change"></el-input-number>
		<div style="display:inline;">~</div>
		<el-input-number :controls="false" v-model="max" @input="change"></el-input-number>
	</div>
</template>
<script>
export default {
	data(){
		return {
			min:'',
			max:'',
		}
	},
	props:{
		value:{
		},
	},
	watch:{
		value(v){
			if(typeof v === 'object'){
				if(parseFloat(v.$gte)){
					this.min = parseFloat(v.$gte);
				}
				if(parseFloat(v.$lte)){
					this.max = parseFloat(v.$lte);
				}
			}
		}
	},
	
	methods:{
		change(){
			const min =  this.min;
			const max =  this.max;
			let v = ''
			if(min || max){
				v = {
					$gte:min||undefined,
					$lte:max||undefined,
				}
			}
			this.$emit('input',v);
			this.$emit('change',v);
			
		}
	}   
}
</script>
